// eslint-disable-next-line no-unused-vars
import ChatRepository from '../../../domain/repositories/ChatRepository';

class EditMessageUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.chatRepository = chatRepository;
    }

    /**
     * Edits an existing message.
     * @param {string} conversationId
     * @param {string} messageId
     * @param {string} newText
     * @returns {Promise<void>}
     */
    async execute(conversationId, messageId, newText) {
        return this.chatRepository.editMessage(conversationId, messageId, newText);
    }
}

export default EditMessageUseCase;
